/* Register your Interest — verified submission. The theme's x-modal owns the modal. */
(function () {
  if (window.__lunburgRI) return;
  window.__lunburgRI = true;

  var turnstileReady;
  var loaderAttempt = 0;
  function loadTurnstile() {
    if (turnstileReady) return turnstileReady;
    turnstileReady = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var callbackName = '__lunburgRITurnstileLoad' + (++loaderAttempt);
      var timer = setTimeout(fail, 15000);
      function fail() {
        clearTimeout(timer);
        delete window[callbackName];
        script.remove();
        reject(new Error('verification_unavailable'));
      }
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=' + callbackName;
      script.async = true;
      window[callbackName] = function () {
        if (!window.turnstile) { fail(); return; }
        clearTimeout(timer);
        delete window[callbackName];
        resolve(window.turnstile);
      };
      script.onerror = fail;
      document.head.appendChild(script);
    }).catch(function (error) { turnstileReady = null; throw error; });
    return turnstileReady;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var modal = document.querySelector('[data-ri-modal]');
    if (!modal) return;
    var form = modal.querySelector('[data-ri-form]');
    if (!form) return;
    var formWrap = modal.querySelector('[data-ri-form-wrap]');
    var success = modal.querySelector('[data-ri-success]');
    var channelEl = modal.querySelector('[data-ri-channel]');
    var errorEl = modal.querySelector('[data-ri-error]');
    var submitBtn = form.querySelector('[type="submit"]');
    var widgetContainer = form.querySelector('[data-ri-turnstile]');
    var widgetId;
    var widgetGeneration = 0;
    var inFlight = false;
    var pendingToken;
    var lastPayload;
    var submissionId;

    function attr(name) { return modal.getAttribute(name) || ''; }
    function fld(name) { return form.querySelector('[name="' + name + '"]'); }
    function val(name) { var f = fld(name); return f ? (f.value || '').trim() : ''; }
    function showError() {
      if (errorEl) {
        errorEl.textContent = 'Something went wrong. Please try again, or write to concierge@lunburg.com.';
        errorEl.hidden = false;
      }
    }
    function tokenFailed() {
      if (pendingToken) pendingToken(new Error('verification_failed'));
      return true;
    }
    function ensureWidget() {
      return loadTurnstile().then(function (turnstile) {
        if (widgetId === undefined) {
          var generation = ++widgetGeneration;
          function widgetFailed() {
            if (generation === widgetGeneration) tokenFailed();
            return true;
          }
          widgetId = turnstile.render(widgetContainer, {
            sitekey: attr('data-ri-sitekey'),
            execution: 'execute',
            appearance: 'interaction-only',
            action: 'register_interest',
            language: 'auto',
            retry: 'never',
            'refresh-expired': 'manual',
            'refresh-timeout': 'manual',
            'response-field': false,
            callback: function (token) {
              if (generation === widgetGeneration && pendingToken) pendingToken(token ? null : new Error('verification_failed'), token);
            },
            'error-callback': widgetFailed,
            'expired-callback': widgetFailed,
            'timeout-callback': widgetFailed,
            'unsupported-callback': widgetFailed
          });
        }
        return turnstile;
      });
    }
    function freshToken() {
      return ensureWidget().then(function (turnstile) {
        turnstile.reset(widgetId);
        return new Promise(function (resolve, reject) {
          var timer = setTimeout(tokenFailed, 120000);
          pendingToken = function (error, token) {
            clearTimeout(timer);
            pendingToken = null;
            if (error) {
              widgetGeneration++;
              turnstile.remove(widgetId);
              widgetId = undefined;
              reject(error);
            } else { resolve(token); }
          };
          try { turnstile.execute(widgetId); }
          catch (error) { pendingToken(error); }
        });
      });
    }

    document.querySelectorAll('[aria-controls="' + modal.id + '"]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (inFlight) return;
        if (formWrap) formWrap.hidden = false;
        if (success) success.hidden = true;
        if (errorEl) errorEl.hidden = true;
        ensureWidget().catch(showError);
      });
    });

    async function send(payload, token) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await fetch(attr('data-ri-endpoint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
          body: JSON.stringify(Object.assign({ submission_id: submissionId, turnstile_token: token }, payload))
        });
        if (!response.ok || (await response.json()).success !== true) throw new Error('submission_failed');
      } finally { clearTimeout(timer); }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (inFlight) return;
      if (errorEl) errorEl.hidden = true;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      inFlight = true;
      form.setAttribute('aria-busy', 'true');
      if (submitBtn) submitBtn.disabled = true;
      try {
        var payload = {
          first_name: val('first_name'),
          last_name: val('last_name'),
          email: val('email'),
          phone: val('phone'),
          preferred_contact: val('preferred_contact'),
          message: val('message'),
          marketing_consent: !!(fld('marketing_consent') && fld('marketing_consent').checked),
          product: {
            product: attr('data-ri-product-title'),
            product_id: attr('data-ri-product-id'),
            product_handle: attr('data-ri-product-handle'),
            product_url: attr('data-ri-product-url'),
            product_type: attr('data-ri-product-type'),
            vendor: attr('data-ri-vendor'),
            variant_id: attr('data-ri-variant-id'),
            sku: attr('data-ri-sku'),
            price: attr('data-ri-price'),
            currency: attr('data-ri-currency'),
            leather_tone: attr('data-ri-config-leather'),
            profile_size: attr('data-ri-config-profile'),
            interior_configuration: attr('data-ri-config-interior')
          }
        };
        var fingerprint = JSON.stringify(payload);
        if (fingerprint !== lastPayload) {
          submissionId = crypto.randomUUID();
          lastPayload = fingerprint;
        }
        var token = await freshToken();
        await send(payload, token);
        lastPayload = null;
        if (channelEl) channelEl.textContent = payload.preferred_contact.toLowerCase();
        if (formWrap) formWrap.hidden = true;
        if (success) success.hidden = false;
      } catch (error) { showError(); }
      finally {
        inFlight = false;
        form.setAttribute('aria-busy', 'false');
        if (submitBtn) submitBtn.disabled = false;
      }
    });
    if (submitBtn) submitBtn.disabled = false;
  });
})();
